import React, { useState } from "react";
import FilterButton from "components/FilterButton";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/MyTooltip";

const allButtonText = "tutte";

const DataChart = ({ data, absoluteFilters, className }) => {
    const [activeFilter, setActiveFilter] = useState(allButtonText);

    const realMax = Math.max(...data.map(({ value }) => value), 1);

    const step = realMax > 500 ? 100 : realMax > 100 ? 50 : 2;

    const chartMax = Math.ceil((realMax * 1.1) / step) * step;

    const tickCount = chartMax / step + 1;

    const filters =
        data && data.length
            ? [
                  allButtonText,
                  ...Object.entries(data[0])
                      .filter(
                          ([filterName, value]) =>
                              typeof value === "number" &&
                              filterName !== "value"
                      )
                      .map((item) => item[0]),
              ]
            : [];

    return (
        <div
            className={`flex h-64 w-full flex-col gap-6 py-6 pl-6 ${
                className ?? ""
            }`}
        >
            {filters && filters.length && (
                <div
                    className={`flex translate-y-[-30%] gap-2 self-end ${
                        absoluteFilters
                            ? "4xl:absolute 4xl:top-0 4xl:right-0 4xl:translate-y-[75%]"
                            : ""
                    }`}
                >
                    {filters.map((filter) => (
                        <React.Fragment key={filter}>
                            <FilterButton
                                text={filter}
                                isActive={filter === activeFilter}
                                onChange={setActiveFilter}
                            />
                        </React.Fragment>
                    ))}
                </div>
            )}

            <div className="relative flex grow items-end gap-3">
                <div className="pointer-events-none absolute inset-0 flex flex-col justify-between">
                    {[...Array(tickCount)].map((_, i) => (
                        <div
                            key={i}
                            className="relative w-full border-t border-gray-200/60"
                        >
                            <span className="absolute -left-4 -top-2 translate-x-[-100%] text-[10px] text-gray-500">
                                {Math.round(
                                    chartMax - (chartMax / (tickCount - 1)) * i
                                )}
                            </span>
                        </div>
                    ))}
                </div>

                <div className="flex h-full w-full items-end gap-3">
                    {data.map((item, index) => {
                        const barValue =
                            activeFilter === allButtonText
                                ? item.value
                                : item[activeFilter];

                        return (
                            <div
                                key={index}
                                className="group z-10 flex h-full flex-1 flex-col items-center justify-end"
                            >
                                <Tooltip placement="bottom">
                                    <TooltipTrigger className="flex h-full w-full items-end">
                                        <div
                                            className="relative w-full rounded-t-[0.65rem] bg-gradient-to-t from-primary-900 to-primary-600 transition-all duration-500 hover:opacity-80"
                                            style={{
                                                height: `${
                                                    (barValue / chartMax) * 100
                                                }%`,
                                            }}
                                        />
                                    </TooltipTrigger>

                                    <TooltipContent className="Tooltip mt-6 !opacity-100">
                                        <span className="mx-2">{barValue}</span>
                                    </TooltipContent>
                                </Tooltip>

                                <div className="absolute -bottom-2 flex translate-y-[100%] flex-col items-center">
                                    <span className="text-[10px] font-bold uppercase tracking-wider text-gray-500 group-hover:text-primary-500">
                                        {item.label}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default DataChart;
